import React from 'react';
import {Button, Card, CardBody, Col, Container, Row} from "reactstrap";
import character from "../../assets/img/backgrounds/congratsCharacter.png"
import {useHistory} from "react-router-dom";

const Congratulation = () => {
    const history = useHistory();

    const visitDashboard = () => {
        history.push("/easy-flow/dashboard");
    }
    const sendInvite = () => {
        history.push("/easy-flow/invitation");
    }

    return (
        <div>
            <Container>
                <div className="d-flex justify-content-center">
                    <Card className="br-60 mt--75 step1-card">
                        <CardBody className="startCard">
                            <Row>
                                <Col sm={12} lg={7} xs={12}>
                                    <div>
                                        <h3 className="font-weight-bold">Congratulation!</h3>
                                        <h4>Your assessment Game has been created.</h4>
                                    </div>
                                    <div className="mt-5">
                                        <p className="fs-12 ml-2 font-weight-bolder mb-2">Game URL has been
                                            activated</p>
                                        <div
                                            className="d-flex copy-link-bg align-items-center justify-content-between p-2">
                                            <span>www.google.com</span>
                                            <Button className="nextButton text-white">Copy</Button>
                                        </div>
                                    </div>
                                    <Row className="mt-6">
                                        <Col lg={6} sm={12} xs={12}>
                                            <Button className="previous-button text-white w-100"
                                                    onClick={visitDashboard}
                                                    color="">Visit Dashboard</Button>
                                        </Col>
                                        <Col lg={6} sm={12}>
                                            <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                                    onClick={sendInvite}
                                                    color="">Send Invites</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm={0} lg={5} xs={0} className="d-none d-lg-block">
                                    <img src={character} height={400}/>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default Congratulation;